import { CodeSandboxOutlined, LinkOutlined, ApiOutlined } from '@ant-design/icons';
import { Alert, Card, Space, Tag, Typography } from 'antd';
import { Link } from '@tanstack/react-router';
import { ModuleDefinition } from '../types';
import { createNavItem } from '@/utils/navigation';

import en from './locales/en.json';
import de from './locales/de.json';
import bg from './locales/bg.json';

const MODULE_NAME = 'demoModule';
const ROUTE_NAMESPACE = 'manage' as const;

export const MODULE_BASE_ROUTE = `/${ROUTE_NAMESPACE}/modules/${MODULE_NAME}`;

function DemoConfigBeforeForm() {
  return (
    <Alert
      type="info"
      title={
        <Space>
          <Tag color="blue">Demo</Tag>
          <span>Custom config UI via extensions.config</span>
        </Space>
      }
      description="This alert is rendered via the config extension point. Modules can add beforeForm and afterForm slots to inject custom UI into the configuration dialog."
      showIcon
    />
  );
}

function DemoConfigAfterForm() {
  return (
    <Card size="small" title="Quick links">
      <Space orientation="vertical" size="small">
        <Typography.Text type="secondary">Resources to get started:</Typography.Text>
        <Link to={MODULE_BASE_ROUTE}>
          <Space>
            <LinkOutlined />
            Open Demo Module page
          </Space>
        </Link>
        <Typography.Text type="secondary">
          <ApiOutlined /> Configure apiUrl and apiToken above, then test connectivity from the module page.
        </Typography.Text>
      </Space>
    </Card>
  );
}

export const module: ModuleDefinition = {
  id: 'demo-module',
  name: 'Demo Module',
  version: '1.0.0',
  description: 'Demo module for testing',
  author: 'System',
  category: 'business',

  routeNamespace: ROUTE_NAMESPACE,
  requiredRoles: ['USER', 'ADMIN'],
  requiredTenantRoles: ['OWNER', 'EMPLOYEE'],
  useServerRelay: true,

  navigationItems: [createNavItem('demo-module', <CodeSandboxOutlined />, 'Demo Module', MODULE_BASE_ROUTE, false)],

  configSchema: {
    type: 'object',
    properties: {
      apiUrl: {
        type: 'string',
        description: 'The base URL for the DemoModule API endpoint',
        required: false,
        serverOnly: true,
      },
      apiToken: {
        type: 'string',
        description: 'The API token for authenticating with the DemoModule API',
        required: false,
        serverOnly: true,
      },
    },
  },

  extensions: {
    config: {
      beforeForm: <DemoConfigBeforeForm />,
      afterForm: <DemoConfigAfterForm />,
    },
  },

  translations: { en, de, bg },
};

export default module;
